module.exports = __webpack_public_path__ + "static/media/npm.f47b343e.jpeg";